import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import Typography from '#web-components/components/Typography';
import Tooltip from '#web-components/components/Tooltip';
import styles from './TopBar.styles';

const useStyles = makeStyles(styles, { name: 'TopBar' });

export interface TopBarProps {
  name: string,
  fullName: string,
}

export default function TopBar({ name, fullName }: TopBarProps) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Tooltip title={fullName} enterDelay={300}>
        <Typography component="span" variant="h6" className={classes.name}>{name}</Typography>
      </Tooltip>
    </Box>
  );
}
